export function sum<T>(collection: T[], callbackfn: (value: T, index: number) => number): number {
    return collection.map(callbackfn).reduce((a, c) => (a || 0) + (c || 0), 0);
}